<template>
  <div>
    <el-row style="margin-bottom: 2vh; height: 6vh">
      <el-col :span="3">
        <el-button icon="el-icon-plus" @click="addGroup">添加分组</el-button>
      </el-col>
      <el-col class="colX">
        <el-button icon="el-icon-search" @click="searchGroups"
          >搜索分组</el-button
        >
      </el-col>
      <el-col class="colG">
        <el-checkbox v-model="checked" label="压缩" border></el-checkbox>
      </el-col>
      <el-col class="colS">
        <el-upload
          :headers="headers"
          :action="uploadImgUrl"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :on-success="handlecuxiaoSuccess"
          :data="uploadData"
          multiple
        >
          <el-button icon="el-icon-upload2">上传图片</el-button>
        </el-upload>
      </el-col>

      <!-- <el-col :span="3" v-if="groupIf">
        <el-button icon="el-icon-close" @click="deleteAll">批量删除</el-button>
      </el-col> -->

      <el-col :span="7" class="col7">
        <el-form
          ref="searchForms"
          :model="searchForms"
          inline
          label-width="88px"
        >
          <el-form-item prop="group" label="搜索图片:">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-input
                  v-model="searchForms.name"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="图片名称"
                  clearable
                  size="small"
                  @change="searchChange"
                />
              </el-col>
              <el-col :span="4">
                <el-button size="small" type="primary" @click="submitForms"
                  >搜索</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8" v-if="groupIf" class="col8">
        <el-form ref="form" :model="formData" inline label-width="88px">
          <el-form-item prop="group" label="移动到分组:">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-select
                  v-model="formData.category_id"
                  placeholder="请选择分组"
                  @change="getGroupId"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in datas"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  />
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-button size="small" type="primary" @click="submitForm"
                  >确定</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2">
        <el-tree
          :data="datas"
          :props="defaultProps"
          size="medium"
          ref="tree"
          :highlight-current="true"
          @node-click="handleTreeNodeClick"
          node-key="id"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span class="delete-icon">
              <i class="el-icon-delete" @click.stop="deleteGroup(data)"></i>
            </span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="20">
        <el-row :gutter="0">
          <div style="width: 100%">
            <el-empty :image-size="200" v-if="images.length === 0"></el-empty>
            <el-col
              class="image-col"
              v-for="(image, index) in images"
              :key="image.id"
              :span="4"
            >
              <div class="image-container">
                <el-image
                  :src="image.url"
                  style="width: 170px; height: 160px; margin-bottom: 1vh"
                  @click="imgClick(image)"
                ></el-image>
                <i
                  v-if="image.url"
                  class="el-icon-close close-icon"
                  @click.stop="deleteImg(image)"
                ></i>
                <div class="image-overlay" v-if="image.select">
                  <span class="selected-text">已选中</span>
                </div>
                <el-tooltip :content="image.name" placement="top">
                  <div class="image-label">{{ image.name }}</div>
                </el-tooltip>
              </div>
            </el-col>
          </div>
        </el-row>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totals"
          @current-change="currentChange"
          :current-page.sync="currentPage1"
          style="position: absolute; bottom: -3.5vh; width: 100%"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getimgGroup,
  getimgList,
  deleteImg,
  addGroup,
  deleteGroup,
  overGroup,
} from "../api/homePage";
import { getCookie } from "../utils/util";
export default {
  data() {
    return {
      checked: false,
      formData: {},
      groupIf: false,
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 上传参数
      uploadData: {
        category_id: "",
        thumb: 1,
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
      images: [],
      datas: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      currentPage1: 1,
      // 移动分组id
      getgroupId: "",
      // 查询列表
      searchForm: {
        category_id: 0,
        page: 1,
      },
      totals: 10,
      // 父组件需要的值
      faData: {},
      faDatas: [],
      searchForms: {},
    };
  },
  mounted() {
    this.getimgGroups();
    this.getimgLists();
  },
  watch: {
    datas() {
      this.$nextTick(() => {
        if (this.datas[0] !== undefined) {
          this.$refs.tree.setCurrentKey(this.datas[0]);
        } else {
          return;
        }
      });
    },
  },
  methods: {
    // 重置事件
    resetSelect() {
      this.images = this.images.map((item) => {
        return {
          ...item,
          select: false,
        };
      });
	  this.faData = {}
	  this.fsDatas = []
    },
    // 获取分组id
    getGroupId(res) {
      this.getgroupId = res;
    },
    // 图片点击事件
    imgClick(res) {
      res.select = !res.select;
      this.groupIf = this.images.some((image) => image.select === true);
	  if(res.select){
		this.faDatas.push(res);
		this.faData = res;
	  }else{
		  let index = -1;
		  this.faDatas.forEach((item,i)=> {
			  if (item.url === res.url) {
				  index = i;
			  }
		  })
		  if (index > -1) {
			  this.faDatas.splice(index,1);
		  }
	  }
    },
    // 找到最后一个为true的图片
    findTrue() {
      this.faData = this.faDatas
        .slice()
        .reverse()
        .find((item) => item.select === true);
    },
    // 批量删除
    deleteAll() {
      const selectedIds = this.images
        .filter((image) => image.select === true)
        .map((image) => image.id);
      deleteImg(selectedIds).then((res) => {
        console.log(res);
      });
    },
    // 获取选中图片
    haveImg() {
      const selectedIds = this.images
        .filter((image) => image.select === true)
        .map((image) => image.id);
    },
    submitForms() {
      getimgList(this.searchForms).then((res) => {
        console.log(res);
        this.images = res.data.records.map((image) => ({
          ...image,
          select: false,
        }));
        this.totals = res.data.total;
      });
      // this.getimgLists(this.searchForms);
    },
    searchChange() {
      this.submitForms();
    },
    searchGroup() {
      getimgGroup(this.searchGroup).then((res) => {
        this.datas = res.data;
        this.datas.unshift({
          id: 0,
          title: "所有图片",
        });
      });
    },
    // 提交事件
    submitForm() {
      const selectedIds = this.images
        .filter((image) => image.select === true)
        .map((image) => image.id);
      const subForm = {
        ids: selectedIds,
        category_id: this.getgroupId,
      };
      overGroup(subForm).then((res) => {
        console.log(res);
        if (res.code !== 200) return this.$message.error("移动失败!");
        this.$message.success("移动成功");
        this.getimgLists();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (this.checked) {
        this.uploadData.thumb = 1;
      } else {
        this.uploadData.thumb = undefined;
      }
      return isJPG;
    },
    handlecuxiaoSuccess() {
      this.$message.success("上传成功");
      this.getimgLists();
    },
    currentChange(res) {
      console.log(res);
      this.searchForm.page = res;
      this.getimgLists();
    },
    // 删除分组
    deleteGroup(req) {
      console.log(req);
      this.$confirm("确定删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await deleteGroup(req.id);
        if (res.code !== 200) return this.$message.error("删除失败!");
        this.$message.success("删除成功");
        this.searchForm.category_id = 0;
        this.getimgLists();
        this.getimgGroups();
      });
    },
    searchGroups() {
      this.$prompt("请输入搜索分组名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,

        // inputErrorMessage: "邮箱格式不正确",
      })
        .then(async ({ value }) => {
          const form = {
            title: value,
          };
          getimgGroup(form).then((res) => {
            this.datas = res.data;
            this.datas.unshift({
              id: 0,
              title: "所有图片",
            });
          });
          //   console.log(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 添加分组
    addGroup() {
      this.$prompt("请输入分组名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,

        // inputErrorMessage: "邮箱格式不正确",
      })
        .then(async ({ value }) => {
          const title = {
            title: value,
          };
          const fnc = await addGroup(title);
          if (fnc.code !== 200) return this.$message.error("添加失败!");
          this.$message.success("添加成功");
          this.getimgGroups();
          //   console.log(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleTreeNodeClick(data, node, elem) {
      this.searchForm.category_id = data.id;
      this.searchForm.page = 1;
      this.currentPage1 = 1;

      this.getimgLists();
      this.uploadData.category_id = data.id;
    },
    // 删除图片
    deleteImg(req) {
      this.$confirm("确定删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await deleteImg(req.id);
        if (res.code !== 200) return this.$message.error("删除失败!");
        this.$message.success("删除成功");
        this.getimgLists();
      });
    },
    // 获取分组
    getimgGroups() {
      getimgGroup().then((res) => {
        console.log(res,'错误')
        this.datas = res.data;
        this.datas.unshift({
          id: 0,
          title: "所有图片",
        });
      });
    },
    // 获取所有图片
    getimgLists() {
      getimgList(this.searchForm).then((res) => {
        this.images = res.data.records.map((image) => ({
          ...image,
          select: false,
        }));
        this.images.forEach(function (item) {
          let url = item.url;
          let extension = url.substr(url.lastIndexOf(".") + 1);
          if (extension === "png" || extension === "jpg") {
          } else {
            item.url =
              "https://st.tfw2020.com/uploads/20231222/1703217404167516.jpg";
          }
        });
        console.log(this.images);
        this.totals = res.data.total;
      });
    },
  },
};
</script>
<style scoped>
/deep/ .el-form--inline .el-form-item {
  display: flex;
}
/deep/ .el-row {
  display: flex;
}
/deep/ .col7 {
  margin-left: 20px;
}
/deep/ .col8 {
  width: 29.33333%;
}
/* /deep/ .el-checkbox__inner::after {
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 24px;
  left: 10px;
  position: absolute;
  top: 1px;
  width: 15px;
} */
/* /deep/ .el-checkbox__inner {
  width: 40px;
  height: 40px;
} */
/deep/ .colG {
  width: 5% !important;
}
/deep/ .colS {
  width: 9% !important;
  margin-left: 20px;
}
/deep/ .colX {
  width: 11%;
}
.image-label {
  text-align: center; /* 文字水平居中对齐 */
  margin: -10px 0 10px 0;
  font-size: 13px; /* 文字大小 */
  color: #333; /* 文字颜色 */
  width: 22vh;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 隐藏溢出部分 */
  text-overflow: ellipsis; /* 用省略号表示溢出部分 */
  cursor: pointer;
}
.image-overlay {
  pointer-events: none;
  /* 添加这行代码 */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 86%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected-text {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}

.image-container {
  position: relative;
  display: inline-block;
}

.close-icon {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 5px;
}

.image-container:hover .close-icon {
  display: block;
}

.image-container:hover .close-icon:hover {
  color: #409eff;
  cursor: pointer;
}

.close-icon:active {
  color: #409eff;
  cursor: pointer;
}

/deep/ .el-col-4 {
  width: 20%;
}
/deep/ .el-col-2 {
  width: 16%;
}
/deep/.el-tree-node {
  margin-bottom: 0.5vh;
}

/deep/ .el-tree {
  font-size: 17px;
  height: 50vh;
  /* 调整高度为适合的数值 */
  overflow-y: auto;
}

.delete-icon {
  position: absolute;
  right: 30px;
}

/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: #6495ed;
}
</style>


// WEBPACK FOOTER //
// src/components/uploadImg.vue